import { useState } from "react";
import { BASKET_COUNT } from "../const/const";
export var useCount = function useCount(initState) {
  var _useState = useState(initState),
    count = _useState[0],
    setCount = _useState[1];

  var increment = function increment() {
    if (count >= BASKET_COUNT.max_count * initState) return;
    else setCount(count + initState);
  };

  var decrement = function decrement() {
    if (count <= BASKET_COUNT.min_count * initState) return;
    else setCount(count - initState);
  };

  return [count, increment, decrement];
};
